import { Skeleton } from '@heroui/react';
import React from 'react';

import { SkeletonWrapper } from './TableSkeleton.styled';

interface TableSkeletonProps {
    rows: number;
    columns: number;
}

export const TableSkeleton: React.FC<TableSkeletonProps> = ({ rows, columns }) => (
  <SkeletonWrapper>
    {Array.from({ length: rows }).map((_, rowIndex) => (
      <div key={rowIndex as unknown as number} className="flex space-x-2">
        {/* eslint-disable-next-line @typescript-eslint/no-shadow */}
        {Array.from({ length: columns }).map((_, colIndex) => (
          <Skeleton
            key={colIndex as unknown as number}
            className="h-8 w-full rounded-sm bg-default-200"
          />
        ))}
      </div>
    ))}
  </SkeletonWrapper>
);
